import { render, staticRenderFns } from "./PromoItemGroupModal.vue?vue&type=template&id=647d0424"
import script from "./PromoItemGroupModal.vue?vue&type=script&lang=js"
export * from "./PromoItemGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4220330617/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647d0424')) {
      api.createRecord('647d0424', component.options)
    } else {
      api.reload('647d0424', component.options)
    }
    module.hot.accept("./PromoItemGroupModal.vue?vue&type=template&id=647d0424", function () {
      api.rerender('647d0424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/PromoItemGroupModal.vue"
export default component.exports